import { AnalyticsSettingsEvent } from 'analytics-api';
import { PieceSelectMarketAnalytics } from './piece-select-market-analytics.models';
import { AnalyticsHelpersOysho } from 'extensions/oy/analytics/helpers/brand-analytics.helpers.oy';

export class PieceSelectMarketAnalyticsTransformer {

  public static setSelectMarketAnalytics(settings: AnalyticsSettingsEvent[]): PieceSelectMarketAnalytics {
    return AnalyticsHelpersOysho.setComponentAnalyticsSettings<PieceSelectMarketAnalytics>(settings, {});
  }

}
